import { render, staticRenderFns } from "./feedback-form.vue?vue&type=template&id=1ce6ef00"
import script from "./feedback-form.vue?vue&type=script&lang=js"
export * from "./feedback-form.vue?vue&type=script&lang=js"
import style0 from "./feedback-form.vue?vue&type=style&index=0&id=1ce6ef00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports